import { create } from 'zustand';

import { FeedbackQuestionIds } from '../../../../backend/src/feedback/feedback-questions';

interface FeedbackRequest {
  questionId: FeedbackQuestionIds;
  metadata?: Record<string, unknown>;
}

interface FeedbackStore {
  request: FeedbackRequest | null;
  showFeedback: (questionId: FeedbackQuestionIds, metadata?: Record<string, unknown>) => void;
  closeFeedback: () => void;
}

export const useFeedbackStore = create<FeedbackStore>((set, get) => ({
  request: null,
  showFeedback: (questionId, metadata) => {
    // Don't replace an active request — the popup component holds local state
    // (response, freeText, submitted) keyed to the current request, and swapping
    // the request out from under it would carry that state into the new question.
    if (get().request) return;
    set({ request: { questionId, metadata } });
  },
  closeFeedback: () => set({ request: null }),
}));
